export default __webpack_public_path__ + "static/media/hm-mg-img.b583065a.webp";